export default {"src":"/_next/static/media/topRightArrow.f04797fc.svg","height":6,"width":6};